module.exports = __webpack_public_path__ + "img/edit.cebf777a.svg";